import { render, staticRenderFns } from "./versionNumber.vue?vue&type=template&id=26aa1a4f&scoped=true&"
import script from "./versionNumber.vue?vue&type=script&lang=js&"
export * from "./versionNumber.vue?vue&type=script&lang=js&"
import style0 from "./versionNumber.vue?vue&type=style&index=0&id=26aa1a4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aa1a4f",
  null
  
)

export default component.exports